const CHIP = "inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-[10px] font-semibold uppercase";

const META = {
  no_claim: ["No Claim", "border-gray-200 bg-gray-50 text-gray-500"],
  partial_outstanding: ["Payment Outstanding", "border-red-200 bg-red-50 text-red-700"],
  final_outstanding: ["Payment Outstanding", "border-red-200 bg-red-50 text-red-700"],
  partial_paid: ["Partial Paid", "border-emerald-200 bg-emerald-50 text-emerald-700"],
  paid: ["Paid", "border-emerald-200 bg-emerald-50 text-emerald-700"],
};

const REGISTER_CHIP = "inline-flex min-h-[34px] min-w-[96px] items-center justify-center gap-1 whitespace-nowrap rounded-md border px-2.5 py-1 text-[10px] font-semibold uppercase leading-tight";

export default function PaymentStatusChip({ status, testId, variant }) {
  const meta = META[status] || META.no_claim;
  return (
    <span data-testid={testId} data-payment-state={status || "no_claim"} className={`${variant === "register" ? REGISTER_CHIP : CHIP} ${meta[1]}`} style={{ letterSpacing: "0.05em" }}>
      {meta[0]}
    </span>
  );
}
